import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Subject, takeUntil } from 'rxjs';
import { TEAM_LIST } from 'src/app/constants/endpoint.const';
import { BaseService } from 'src/app/services/base.service';

interface Person {
  key: string;
  name: string;
  email: string;
  role: string;
  status: string;
  id: number;
}

@Component({
  selector: 'app-teams',
  standalone: false,
  templateUrl: './teams.component.html',
  styleUrl: './teams.component.scss'
})
export class TeamsComponent {
  $destroy = new Subject
  loading: boolean = true;
  showDelete: boolean = false;
   @Output() openNotifDrawerhEvent = new EventEmitter<boolean>();
  listOfData: Person[] = [];
  idTeam: number = 0;

  constructor(
    private route: Router,
    private baseService: BaseService,
    private message: NzMessageService,
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
    this.getTeam()
  }

  addTeam(): void {
    this.route.navigate(['/teams/add-team'])
  }

  getClassStatus(v: string) {
    if (v === 'Activated' || v === 'activated') return 'activated'
    if (v === 'Deactivated' || v === 'deactivated') return 'deactivated'
    if (v === 'Not Activated' || v === 'not activated') return 'deactivated'
    if (v === 'Pending' || v === 'pending') return 'pending'
    return ''
  }

  deleteTeam(id: number) {
    this.idTeam = id
    this.showDelete = true
  }

  editTeam(id: number) {
    this.route.navigate([`/teams/edit-team/${id}`])
  }

  successDelete() {
    this.showDelete = false
    this.getTeam()
  }

  getTeam() {
    this.baseService.getData(TEAM_LIST)
      .pipe(takeUntil(this.$destroy))
      .subscribe((res) => {
        this.listOfData = res.data.teams
      }, (err) => {
        this.message.error("Failed get team's data")
    })
  }

  changeStatus(id: number, status: string) {
    if (status === 'Pending') {
      this.message.info('Pending Status Can Only Be Changed via Email Verification');
    } else {
      const params = {
        status: status === 'Activated' || status === 'activated' ? 'Not Activated' : 'Activated'
      }
      this.baseService
        .putData(TEAM_LIST + `/update-status/${id}`, params)
        .pipe(takeUntil(this.$destroy))
        .subscribe(
          (res) => {
            this.message.success("Update Status Team's Success");
            this.getTeam()
          },
          (err) => {
            this.message.success(err.error.meta.message);
          }
        );
    }
  }
}
